export default __webpack_public_path__ + "static/media/p2023-35.220709d5.jpeg";